import { Modal } from 'antd';
import { message, Upload } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from "../../utils/selfRequest";
// import { globalUrl } from "utils/request";
import { noTags } from "../../utils/common";
import { language } from "@/utils/language";
import { ImagePicker, Toast } from 'antd-mobile';
import PubSub from "pubsub-js";

const UploadFelsProgress = (props) => {
  const { children, felsType, uploadType, size, maxCount, uploadSuccessRes, picListLength, setLoading } = props;
  const [uploadFileList, setUploadFileList] = useState([]);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
  const currentUploadType = Number(uploadType);
  const fileTypes = Array.isArray(felsType) ? felsType : [];
  const imageFileTypes = ['gif', 'png', 'jpg', 'jpeg', 'bmp', 'webp', 'heic', 'heif'];
  const isAndroidMobileUpload = isAndroid && isMobile && (currentUploadType === 1 || currentUploadType === 2);
  const androidUploadAccept = (() => {
    if (!isAndroidMobileUpload) return undefined;
    if (currentUploadType === 1) return 'image/*,*/*';
    if (fileTypes.length === 0) return 'image/*,*/*';

    const acceptFileTypes = fileTypes.map(item => `.${item}`);
    const allowImage = fileTypes.some(item => imageFileTypes.includes(`${item}`.toLowerCase()));
    return allowImage ? ['image/*', ...acceptFileTypes].join(',') : acceptFileTypes.join(',');
  })();

  useEffect(() => {
    if (uploadFileList.length > 0) {
      customRequest();
    }
  }, [uploadFileList]);

  // 文件上传前的拦截
  const beforeUploadHandle = (file, fileList) => {
    setUploadFileList([...uploadFileList, ...fileList]);
    return false;
  }
  // 校验上传文件的格式
  const filterUploadFileList = () => {
    return new Promise((reslove, reject) => {
      if (currentUploadType !== 2 || fileTypes.length === 0) {
        reslove(true);
        return;
      }
      for (let index = 0; index < uploadFileList.length; index++) {
        const file = uploadFileList[index];
        const ary = file.name.split(".");
        const isJpgOrPng = fileTypes.includes(ary[ary.length - 1].toLowerCase());
        if (!isJpgOrPng) {
          if (sessionStorage.getItem("internationalizeFlag") == "jap") {
            //形式のファイルをアップロードしてください。
            PubSub.publish("Modalalert", `【${noTags(props.info.description)} 】    ${felsType.toString()}形式のファイルをアップロードしてください。`);
          } else {

            PubSub.publish("Modalalert", `【${noTags(props.info.description)}】${language().upload_file_qs}${felsType.toString()},${language().upload_file_type}`);

          }
          setUploadFileList([]);
          reject(false);
          break;
        } else if ((file.size / 1024 / 1024) > size) {
          if (sessionStorage.getItem("internationalizeFlag") == "jap") {
            //
            PubSub.publish("Modalalert", `【${noTags(props.info.description)}】    ${size}メガバイト以内のファイルをアップロードしてください`);

          } else {
            PubSub.publish("Modalalert", `【${noTags(props.info.description)}】${language().upload_file}${size}${language().upload_file_size}`);
          }
          setUploadFileList([]);
          reject(false)
          break;
        }
        reslove(true);
      }
    })
  }
  // 上传
  const customRequest = async () => {
    if (picListLength + uploadFileList.length > maxCount) {

      if (sessionStorage.getItem("internationalizeFlag") == "jap") {
        PubSub.publish("Modalalert", `${noTags(props.info.description)}最大で【${maxCount}】つのファイルのアップロードが許可されています`);
      } else {
        PubSub.publish("Modalalert", `【${noTags(props.info.description)}】${language().upload_most}   ${maxCount}   ${language().upload_file_number}`);
      }
      setUploadFileList([]);
      return false;
    }
    const dataFalg = await filterUploadFileList();
    if (!dataFalg) return;
    const formData = new FormData();
    uploadFileList.forEach((file) => {
      formData.append('files', file);
    })
    setLoading(true);
    axios.post(`answer/test/uploadAnswerFile?questionId=${props?.info?.id}&sampleId=${props?.info?.sampleId}`, formData).then((res) => {
      const { msg, data } = res;
      if (data.length > 0) {
        uploadSuccessRes(data);
        setUploadFileList([]);
      } else {
        PubSub.publish("Modalalert", msg);
        setUploadFileList([]);
      }
      setLoading(false);
    }).catch((err) => {
      setUploadFileList([]);
      setLoading(false);
      PubSub.publish("Modalalert", err.msg || '系统异常');
    })
  }

  return (
    <Upload
      multiple={maxCount === 1 ? false : true}
      customRequest={customRequest}
      name='file'
      fileList={[]}
      maxCount={maxCount}
      accept={androidUploadAccept}
      beforeUpload={beforeUploadHandle}
    >
      {children}
    </Upload>
  )
}

export default UploadFelsProgress;
